export const inferenceFilesCountKeys = {
  all: (modelId: string) => ["inferenceFileCounts", modelId],
};

export const annotationFilesCountKeys = {
  all: (modelId: string) => ["annotationFileCounts", modelId],
};

export const queryKeys = {
  model: (modelId: string) => ["model", modelId],
  reviewStages: {
    model: (modelId: string) => ["reviewStages", modelId],
    byId: (modelId: string, stageId: string) => [
      "reviewStages",
      modelId,
      stageId,
    ],
  },
  inference: {
    lists: (modelId: string) => ["imageLevelInferences", modelId],
    list: (modelId: string, filters: any) => [
      ...queryKeys.inference.lists(modelId),
      { filters },
    ],
    fileOrPage: (modelId: string) => ["imageLevelInference", modelId],
    file: (modelId: string, fileId: string) => [
      ...queryKeys.inference.fileOrPage(modelId),
      fileId,
    ],
    page: (modelId: string, pageId: string) => [
      ...queryKeys.inference.fileOrPage(modelId),
      pageId,
    ],
    hasFiles: (modelId: string) => ["hasInferenceFiles", modelId],
  },
  export: {
    model: (modelId: string) => ["exportinfo", modelId],
  },
  featureFlags: (email: string) => ["featureFlags", email],
  validationErrors: (modelId: string, fileId: string) => [
    "validationErrors",
    { modelId, fileId },
  ],
  exportHistory: (fileId: string) => ["exportRunHistory", { fileId }],
  modelLog: (modelId: string) => ["modelChangelog", modelId],
  fileLog: (modelId: string, fileId: string) => [
    "fileActivityLog",
    { modelId, fileId },
  ],
};
